import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { DiagnosticRating } from '@malou-io/package-utils';

import { PartnerThemeContext } from ':core/context/partner-theme.context';
import { RatingChipComponent } from ':modules/rating-chip/rating-chip.component';
import { ImagePathResolverPipe } from ':shared/pipes/image-path-resolver.pipe';

const DEFAULT_ZERO_DISPLAYED_VALUE = '-';

@Component({
    selector: 'app-social-network-rating-box',
    imports: [NgClass, RatingChipComponent, ImagePathResolverPipe],
    templateUrl: './social-network-rating-box.component.html',
    styleUrl: './social-network-rating-box.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialNetworkRatingBoxComponent {
    readonly isDiagnosticRestaurant = input.required<boolean>();
    readonly value = input.required<string | number>();
    readonly description = input.required<string>();
    readonly diagnosticRating = input<DiagnosticRating>();

    private readonly _partnerThemeContext = inject(PartnerThemeContext);

    DiagnosticRating = DiagnosticRating;

    readonly isValueZero = computed(() => {
        const value = this.value();
        if (typeof value === 'number') {
            return value === 0;
        }
        return false;
    });
    readonly shouldDisplayBadRating = computed(() => this.diagnosticRating() === DiagnosticRating.BAD && !this.isValueZero());

    readonly displayedZeroValue = computed(
        () => this._partnerThemeContext.activeTheme()?.zeroDisplayedValue ?? DEFAULT_ZERO_DISPLAYED_VALUE
    );
    readonly formattedValue = computed(() => (this.isValueZero() ? this.displayedZeroValue() : this.value().toString()));
}
